module.exports = __webpack_public_path__ + "img/logo-icon1.9bd88959.png";